// github: https://github.com/videojs/video.js
// api docs: https://docs.videojs.com/docs/api/player.html

import 'video.js/dist/video-js.min.css'
import videoZhCN from 'video.js/dist/lang/zh-CN.json'
import { isAd } from '../../util'

export default {
  name: 'Home',
  data() {
    return {
      videoId: 'gubi',
      videoUrl: process.env.VUE_APP_PUBLIC_PATH + 'gubi.mp4',
      currentGallery: 'k2-s',
      showCircle: true,
      // startTime: '',
      // animationTotalTime: 6, // 一套音符动画执行的时间
      isAd: isAd(),
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.initVideoJS()
    // this.$refs.video.addEventListener('playing', this.playingHandler)
    // this.$refs.video.addEventListener('pause', this.endedHandler)
    // this.$refs.video.addEventListener('ended', this.endedHandler)
  },
  beforeDestroy() {
    // video.js 销毁实例
    this.videoInstance && this.videoInstance.dispose()
    // 消除画中画
    this.exitPictureInPicture()
    // 注销播放状态监听
    // this.$refs.video.removeEventListener(this.playingHandler)
    // this.$refs.video.removeEventListener(this.endedHandler)
    // this.$refs.video.removeEventListener(this.endedHandler)
  },
  methods: {
    scrollToBottom() {},
    initVideoJS() {
      // 异步加载 video.js
      import('video.js').then(({ default: Video }) => {
        Video.addLanguage('zh-CN', videoZhCN)
        try {
          this.videoInstance = Video(this.videoId, {
            muted: false,
            controls: true,
            autoplay: false,
            preload: true,
            loop: false,
            language: 'zh-CN',
          })
        } catch (e) {
          console.log('video.js: ', e)
        }
      })
    },
    // playingHandler() {
    //   console.log('playingHandler ......')
    // },
    // endedHandler() {
    //   console.log('endedHandler ......')
    // },
    // 请求画中画
    requestPictureInPicture() {
      if (this.$refs.video.requestPictureInPicture) {
        this.$refs.video.requestPictureInPicture().catch((e) => {
          console.log(e)
        })
      }
    },
    // 退出画中画
    exitPictureInPicture() {
      if (window.document.exitPictureInPicture) {
        window.document.exitPictureInPicture().catch((e) => {
          console.log(e)
        })
      }
    },
    // 点击购买体验课按钮
    handleBuyCourseClick() {
      if (this.isAd) {
        this.$router.push('/course')
      } else {
        window.scrollTo({
          left: 0,
          top: this.$refs.buyCourseAnchor.offsetTop,
          behavior: 'smooth',
        })
      }
    },
    // 检测视频是否正在播放
    isPlaying() {
      return /vjs-playing/.test(
        document.getElementById(this.videoId).getAttribute('class')
      )
    },
    // 滚动监听
    handleScroll() {
      // 防抖
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = window.setTimeout(() => {
        // 头部 fixed 区域的高度
        const offset = 162
        // getBoundingClientRect() 方法返回元素的大小及其相对于视口的位置
        if (this.isPlaying()) {
          const videoContainerRect = this.$refs.videoContainer.getBoundingClientRect()
          if (videoContainerRect.height + videoContainerRect.top - offset < 0) {
            this.requestPictureInPicture()
          }
          if (videoContainerRect.top - offset > 0) {
            this.exitPictureInPicture()
          }
        }

        const chainContainerRect = this.$refs.chainContainer.getBoundingClientRect()
        if (chainContainerRect.top < window.innerHeight) {
          this.showCircle = true
        } else {
          this.showCircle = false
        }
        if (chainContainerRect.height + chainContainerRect.top - offset < 0) {
          this.showCircle = false
        }
      }, 100)
    },
    // 一课一袋
    handleThumbnailHover(type) {
      this.currentGallery = type
    },
  },
}
